module.exports = __webpack_public_path__ + "static/slide3-382265ba8681f3b157e391b51547772e.jpg";